import { useLocation } from "react-router-dom";
import { useSession, type AdminModeState } from "@jkast90/kast-common/auth";
import { session, signIn } from "@common/auth/session";
import { BugReportPage as SharedBugReportPage } from "@jkast90/kast-common/bug-report-form";
import { buttonClass } from "@jkast90/kast-common/ui";

const CLASSES = {
  button: buttonClass(),
  primaryButton: buttonClass({ variant: "primary" }),
  hint: "muted small",
  logButton: buttonClass({ size: "sm" }),
  logPrimaryButton: buttonClass({ variant: "primary", size: "sm" }),
};

const getToken = () => session.bearer();

/**
 * /bug-report: reports go to the kast-dev admin inbox, not salvagers-api.
 * Pre-filled with the crash when arriving from the crash screen.
 */
export default function BugReportPage({ adminMode }: { adminMode: AdminModeState }) {
  const { user } = useSession();
  const { state } = useLocation();
  return (
    <main className="page">
      <SharedBugReportPage
        app="salvagersgame"
        user={user ? { id: user.sub, email: user.email } : null}
        getToken={getToken}
        onUnauthorized={session.onUnauthorized}
        onSignIn={signIn}
        navigationState={state}
        title="Report a bug"
        showLogs={adminMode.unlocked}
        logsTitle="Attached logs"
        classNames={CLASSES}
      />
    </main>
  );
}
